import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
  Spinner,
  FormGroup
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

// Import Breadcrumb & Toastr
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// Redux
import { useDispatch } from "react-redux";

// --- API YAPILANDIRMASI ---
const API_BASE = "https://dlaviapi.stechomeyazilim.info";
const UPLOAD_ENDPOINT = "https://dlaviadmin.stechomeyazilim.info/Uploads/uploads.php";
const FILE_BASE_URL = "https://dlaviadmin.stechomeyazilim.info/Uploads/";

const API_URLS = {
  list:   `${API_BASE}/Strategy`,
  add:    `${API_BASE}/Strategy`,
  update: (id) => `${API_BASE}/Strategy(${id})`,
  delete: (id) => `${API_BASE}/Strategy(${id})`,
};

const ContactsList = props => {
  document.title = "Strateji Yönetimi | DLApro";

  const dispatch = useDispatch();
  
  // Local States
  const [strategyList, setStrategyList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [dataToDelete, setDataToDelete] = useState(null);
  
  // Yükleme Durumları
  const [uploadingImage, setUploadingImage] = useState(false);

  // --- VERİ ÇEKME ---
  useEffect(() => {
    fetchStrategies();
  }, []);

  const fetchStrategies = async () => {
    try {
      const res = await axios.get(API_URLS.list);
      // Sort alanına göre sıralama (Küçükten büyüğe)
      const sorted = (res.data.value || []).sort((a, b) => (a.Sort || 0) - (b.Sort || 0));
      setStrategyList(sorted);
    } catch (error) {
      console.error("Stratejiler çekilemedi:", error);
      showToast("Hata", "Veri çekilemedi", false);
    }
  };

  // --- DOSYA YÜKLEME ---
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingImage(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
        const res = await axios.post(UPLOAD_ENDPOINT, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (res.data && res.data.status) {
            validation.setFieldValue("Strategy_Image", res.data.url);
            showToast("Başarılı", "Resim yüklendi.", true);
        } else {
            showToast("Hata", res.data.message || "Yükleme başarısız.", false);
        }
    } catch (error) {
        console.error("Upload hatası:", error);
        showToast("Hata", "Sunucu hatası oluştu.", false);
    } finally {
        setUploadingImage(false);
    }
  };

  // --- FORMIK & YUP ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ID: (editData && editData.ID) || 0,
      Strategy_Title: (editData && editData.Strategy_Title) || "",
      Strategy_Desc: (editData && editData.Strategy_Desc) || "",
      Sort: (editData && editData.Sort) || 0,
      Strategy_Image: (editData && editData.Strategy_Image) || "",
    },
    validationSchema: Yup.object({
      Strategy_Title: Yup.string().required("Strateji başlığı zorunludur."),
      Sort: Yup.number().typeError("Sıralama sayı olmalıdır.")
    }),
    onSubmit: (values) => {
      handleFinalSubmit(values);
    },
  });

  // --- KAYDET / GÜNCELLE ---
  const handleFinalSubmit = async (values) => {
    const payload = {
      Strategy_Title: values.Strategy_Title,
      Strategy_Desc: values.Strategy_Desc,
      Sort: parseInt(values.Sort) || 0,
      Strategy_Image: values.Strategy_Image
    };

    try {
      if (isEdit) {
        await axios.patch(API_URLS.update(values.ID), payload);
        showToast("Başarılı", "Strateji güncellendi.", true);
      } else {
        console.log("şlkmşsdfd", payload)
        await axios.post(API_URLS.add, payload);
        showToast("Başarılı", "Strateji eklendi.", true);
      }
      toggle();
      fetchStrategies();
    } catch (error) {
      console.error("Kaydetme hatası:", error);
      showToast("Hata", "İşlem başarısız.", false);
    }
  };

  // --- SİLME ---
  const onDeleteConfirm = async () => {
    if (dataToDelete && dataToDelete.ID) {
      try {
        await axios.delete(API_URLS.delete(dataToDelete.ID));
        showToast("Başarılı", "Kayıt silindi.", true);
        fetchStrategies();
      } catch (error) {
        showToast("Hata", "Silme işlemi başarısız.", false);
      }
    }
    setDeleteModal(false);
  };

  // --- YARDIMCILAR ---
  const showToast = (title, message, isSuccess) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 3000 };
    if (isSuccess) toastr.success(message, title);
    else toastr.error(message, title);
  };

  const toggle = () => {
    if (modal) {
      setEditData(null);
      setIsEdit(false);
      validation.resetForm();
    }
    setModal(!modal);
  };

  const handleEditClick = (row) => {
    setEditData(row);
    setIsEdit(true);
    setModal(true);
  };

  const handleDeleteClick = (row) => {
    setDataToDelete(row);
    setDeleteModal(true);
  };

  // --- TABLO KOLONLARI ---
  const columns = useMemo(
    () => [
      {
        Header: "Sıra",
        accessor: "Sort",
        Cell: ({ value }) => <span className="fw-bold">{value}</span>
      },
      {
        Header: "Görsel",
        accessor: "Strategy_Image",
        Cell: ({ value }) => (
            value ? 
            <img src={value} alt="Strateji" style={{height: '40px', borderRadius: '4px'}} /> 
            : <span className="text-muted">-</span>
        )
      },
      {
        Header: "Başlık",
        accessor: "Strategy_Title",
        Cell: ({ value }) => <span className="fw-bold text-primary">{value}</span>
      },
      {
        Header: "Açıklama",
        accessor: "Strategy_Desc",
        Cell: ({ value }) => (value && value.length > 50 ? value.substring(0, 50) + "..." : value) || "-"
      },
      {
        Header: "İşlemler",
        Cell: cellProps => (
          <div className="d-flex gap-3">
            <Link to="#" className="text-success" onClick={() => handleEditClick(cellProps.row.original)}>
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">Düzenle</UncontrolledTooltip>
            </Link>
            <Link to="#" className="text-danger" onClick={() => handleDeleteClick(cellProps.row.original)}>
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">Sil</UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={onDeleteConfirm} onCloseClick={() => setDeleteModal(false)} />
      
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Stratejiler" />
          
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={strategyList}
                    isGlobalFilter={true}
                    isAddAvailable={true} // Add butonu için (Generic component yapısına göre isimlendirme değişebilir)
                    handleOrderClicks={toggle} // Ekleme butonuna tıklayınca modal aç
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle} tag="h4">
              {isEdit ? "Stratejiyi Düzenle" : "Yeni Strateji Ekle"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                
                <Row>
                    <Col md={8}>
                        <FormGroup className="mb-3">
                            <Label>Strateji Başlığı</Label>
                            <Input name="Strategy_Title"
                                type="text"
                                placeholder="Başlık giriniz"
                                onChange={validation.handleChange} onBlur={validation.handleBlur}
                                value={validation.values.Strategy_Title}
                                invalid={!!(validation.touched.Strategy_Title && validation.errors.Strategy_Title)}
                            />
                            <FormFeedback>{validation.errors.Strategy_Title}</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup className="mb-3">
                            <Label>Sıralama (Sort)</Label>
                            <Input name="Sort"
                                type="number"
                                onChange={validation.handleChange}
                                value={validation.values.Sort}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <FormGroup className="mb-3">
                            <Label>Açıklama / İçerik</Label>
                            <Input name="Strategy_Desc"
                                type="textarea"
                                rows={5}
                                placeholder="Strateji detaylarını buraya yazınız..."
                                onChange={validation.handleChange}
                                value={validation.values.Strategy_Desc}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                {/* RESİM YÜKLEME ALANI */}
                <Card className="border border-light bg-light mb-3">
                    <CardBody>
                        <h6 className="card-title mb-3"><i className="mdi mdi-image text-primary"></i> Strateji Görseli</h6>
                        <Row>
                            <Col md={8}>
                                <Input name="Strategy_Image"
                                    placeholder="Görsel URL (Otomatik dolar)"
                                    onChange={validation.handleChange}
                                    value={validation.values.Strategy_Image}
                                    disabled
                                />
                            </Col>
                            <Col md={4}>
                                <div style={{ position: 'relative', overflow: 'hidden' }}>
                                    <Button color="info" block disabled={uploadingImage}>
                                        {uploadingImage ? <Spinner size="sm" /> : <><i className="mdi mdi-cloud-upload"></i> Yükle</>}
                                    </Button>
                                    <Input type="file" 
                                        style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                                        onChange={handleFileUpload}
                                        accept="image/*"
                                    />
                                </div>
                            </Col>
                        </Row>
                        {validation.values.Strategy_Image && (
                            <div className="mt-3 text-center">
                                <img 
                                    src={FILE_BASE_URL + validation.values.Strategy_Image} 
                                    alt="Önizleme" 
                                    style={{ maxHeight: '150px', borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }} 
                                />
                            </div>
                        )}
                    </CardBody>
                </Card>

                <div className="d-flex justify-content-end mt-4 gap-2">
                    <Button color="secondary" onClick={toggle}>İptal</Button>
                    <Button type="submit" color="success">
                        {isEdit ? "Değişiklikleri Kaydet" : "Kaydet"}
                    </Button>
                </div>

              </Form>
            </ModalBody>
          </Modal>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);